<div *ngIf="buttonVisible">
    <button mat-raised-button color="primary" (click)="execute()">{{ buttonText }}</button>
</div>
